// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"9b0bbec7","299":"a3edaf37","865":"63a9fd46"}[chunkId] + ".chunk.js";
};